import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'design-system';
import { DataFilterSubskrypcjeService } from 'src/app/services/data-filter-subskrypcje.service';
import {environment} from "../../../environments/environment";
import {NewsletterService} from '../../services/newsletter.service';

@Component({
  selector: 'app-monitorowane-podmioty-w-krs',
  templateUrl: './monitorowane-podmioty-w-krs.component.html',
  styleUrls: ['./monitorowane-podmioty-w-krs.component.scss'],
})
export class MonitorowanePodmiotyWKrsComponent implements OnInit, AfterViewInit {
  readonly env = environment;
  index: number = 0;
  showFilter: boolean = false;
  filterLabel: string;
  newsletterKomunikat = {
    tresc: this.env.newsletterKomunikatTresc,
    tytul: this.env.newsletterKomunikatNaglowek,
    typ: 'info',
  }

  constructor(
    private breadcrumbService: BreadcrumbService,
    private newsletterService: NewsletterService,
    private router: Router,
    public dataFilterService: DataFilterSubskrypcjeService
  ) {
    this.router.onSameUrlNavigation = 'reload';
  }

  ngOnInit(): void {
    this.updateBreadcrumbs();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if(this.router.url == '/powiadomienia') {
        this.index = 1;
      }
    });
  }

  updateBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumbList([
      {
        label: 'Portal Rejestrów Sądowych',
        path: this.env.portalUrl,
      },
      {
        label: 'Krajowy Rejestr Sądowy',
        path: this.env.portalUrl + '/krs',
      },
      {
        label: 'Monitorowane podmioty w KRS',
        path: '/',
      },
    ]);
  }

  tabChanged(index: number) {
    this.dataFilterService.loading$.next(true);
    this.newsletterService.selectedTabIndex$.next(index);
  }
}

